import {
  ReturnOrderSearchRes,
  ReturnWorkScanHead,
  ReturnWorkScanHeadRes,
  ReturnWorkScanItemRes,
  ReturnWorkScanRow,
} from './types'

/** `ReturnWorkScanHeadRes`·`ReturnOrderSearchRes` 가 공통으로 갖는, 운송장 패널 매핑에 필요한 필드. */
interface ReturnWorkHeadSource {
  sprNm: string | null
  trsInvoiceNo: string | null
  ordNm: string | null
  trsNm: string | null
  trsMobile: string | null
  trsPhone: string | null
  trsAddr: string | null
  trsZip: string | null
}

const toHead = (res: ReturnWorkHeadSource): ReturnWorkScanHead => ({
  shipperCode: res.sprNm ?? '',
  returnInvoiceNumber: '',
  originalInvoiceNumber: res.trsInvoiceNo ?? '',
  orderName: res.ordNm ?? '',
  receiverName: res.trsNm ?? '',
  receiverPhone: res.trsMobile || res.trsPhone || '',
  receiverAddress: res.trsAddr ?? '',
  receiverZip: res.trsZip ?? '',
})

/** HEAD 응답 첫 행 → 운송장 패널. 휴대폰이 있으면 우선 쓰고 없으면 전화번호로 대체한다. */
export const toReturnWorkScanHead = (res: ReturnWorkScanHeadRes): ReturnWorkScanHead => toHead(res)

/** 주문검색 결과 선택 → 운송장 패널. HEAD 를 다시 조회하지 않고 고른 행을 그대로 헤더로 쓴다(5단계, 1.0 동일). */
export const orderSearchResultToHead = (res: ReturnOrderSearchRes): ReturnWorkScanHead => toHead(res)

/**
 * ITEM 응답 → 그리드 행. `orderNumber` 는 호출부가 `ordNoMax` 부터 1씩 증가시켜 부여한다(2단계).
 * 편집 셀 6필드(반품처·반품택배·반품계좌·반송금액·착불금액·선/착불)는 조회 응답에 없는 값이라
 * 빈 문자열로 시작한다 — 작업자가 표에서 직접 채운다(LOGISPRD-12384).
 */
export const toReturnWorkScanRow = (res: ReturnWorkScanItemRes, orderNumber: string, key: string): ReturnWorkScanRow => ({
  key,
  orderNumber,
  barcode: res.barcode ?? '',
  skuId: res.skuId ?? '',
  goodsCode: res.gdsCd ?? '',
  goodsName: res.gdsNm ?? '',
  goodsOption: res.gdsOpt ?? '',
  goodsColor: res.gdsColor ?? '',
  goodsGroup1: res.gdsGroup1 ?? '',
  goodsAttribute1: res.gdsAttr1 ?? '',
  styleNumber: res.stlNo ?? '',
  brandName: res.brdNm ?? '',
  orderQuantity: res.ordQty ?? 1,
  salesChannel: res.salChannel ?? '',
  referenceNumber1: res.refNo1 ?? '',
  referenceNumber2: res.refNo2 ?? '',
  condition: '',
  procurementName: '',
  duplicate: false,
  rlChannel: '',
  logisticsProviderName: '',
  etc1: '',
  etc2: '',
  etc3: '',
  etc4: '',
  insDate: '',
  insBy: '',
  updDate: '',
  updBy: '',
})
